export const NO_AUTH_TOKEN_PATTERNS = [
  /idp\/.*\/iris\/login\/users$/i,
  /idp\/.*\/azure\/oauth2\/authorize\/v2/i,
  /idp\/.*\/iris\/tokens\/refresh/i,
  /\/security\/users\/send-reset-email\?email=.*/i,
  /.+\/api\/login-jwt$/i,
  /\/security\/users\/reset-pwd\?.*/i,
];
